import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Phone, MessageSquare, ArrowRight } from "lucide-react";
import { company } from "../data/mock";

const STEPS = [
  "We review your details and photos.",
  "Chris texts you with your itemized quote.",
  "You approve the quote and we lock in your install date.",
];

export const QuoteSuccess = ({ name, children, smsHref = company.photoSms }) => (
  <div className="max-w-2xl py-10 sm:py-14" data-testid="quote-success">
    <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-emerald-500/10 text-emerald-700 border border-emerald-500/20 text-xs font-bold uppercase tracking-wider">
      <CheckCircle2 className="w-4 h-4" /> Request received
    </span>
    <h1 className="text-3xl sm:text-4xl font-extrabold text-[#0a1f44] mt-4" data-testid="quote-success-title">You're all set, {name}!</h1>
    <div className="text-slate-600 mt-3 leading-relaxed">{children}</div>

    <div className="mt-8 rounded-2xl bg-[#f5f8ff] border border-[#3b9dff]/20 p-6 sm:p-7 tex-grid-light overflow-hidden">
      <p className="font-bold text-[#0a1f44]">What happens next</p>
      <ol className="mt-4 space-y-4" data-testid="what-happens-next-list">
        {STEPS.map((s, i) => (
          <li key={s} className="flex items-start gap-4">
            <span className="w-8 h-8 shrink-0 rounded-full bg-[#3b9dff] text-white font-extrabold text-sm flex items-center justify-center shadow-[0_6px_16px_-4px_rgba(59,157,255,0.6)]">{i + 1}</span>
            <span className="pt-1 text-[#0a1f44]">{s}</span>
          </li>
        ))}
      </ol>
    </div>

    <div className="mt-6 grid sm:grid-cols-2 gap-3">
      <a href={company.phoneLink} data-testid="quote-call-button" className="flex items-center justify-center gap-2 py-3.5 px-5 rounded-xl bg-[#0a1f44] hover:bg-[#06142e] text-white font-semibold shadow-md transition-colors">
        <Phone className="w-4 h-4" /> Call {company.phone}
      </a>
      <a href={smsHref} data-testid="quote-text-button" className="flex items-center justify-center gap-2 py-3.5 px-5 rounded-xl bg-[#3b9dff] hover:bg-[#2b8ae8] text-white font-semibold shadow-md transition-colors">
        <MessageSquare className="w-4 h-4" /> Text {company.phone}
      </a>
    </div>
    <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2">
      <Link to="/recent-installs" data-testid="recent-installs-link" className="inline-flex items-center gap-1.5 text-[#3b9dff] hover:text-[#2b8ae8] font-semibold text-sm underline underline-offset-4">
        See our recent installs <ArrowRight className="w-4 h-4" />
      </Link>
      <Link to="/" data-testid="quote-success-home-link" className="text-slate-500 hover:text-[#0a1f44] font-semibold text-sm underline underline-offset-4">Back to home</Link>
    </div>
  </div>
);
